import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './client';
export function useListPlayers() {
    return useQuery({
        queryKey: ['players'],
        queryFn: () => api.request('/api/players'),
    });
}
export function useGetPlayer(playerId) {
    return useQuery({
        queryKey: ['players', playerId],
        queryFn: () => api.request(`/api/players/${playerId}`),
        enabled: playerId > 0,
    });
}
export function useCreatePlayer() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (body) => api.request('/api/players', {
            method: 'POST',
            body: JSON.stringify(body),
        }),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['players'] }),
    });
}
export function useUpdatePlayer() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ playerId, body }) => api.request(`/api/players/${playerId}`, {
            method: 'PATCH',
            body: JSON.stringify(body),
        }),
        onSuccess: (_data, { playerId }) => {
            void qc.invalidateQueries({ queryKey: ['players'] });
            void qc.invalidateQueries({ queryKey: ['players', playerId] });
        },
    });
}
